import * as React from "react";
const ZigZag = (props) => (
  <svg
    width={19}
    height={11}
    viewBox="0 0 19 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.2236 1.02051L15.2446 9.13285C15.1009 9.52414 14.5475 9.52414 14.4038 9.13285L11.8455 2.16594C11.7017 1.77458 11.1482 1.77468 11.0046 2.16609L8.44942 9.13207C8.30585 9.52348 7.7523 9.52358 7.60859 9.13222L5.05023 2.16531C4.90654 1.77402 4.35314 1.77402 4.20945 2.16531L1.23047 10.2777"
      stroke={props.color}
      strokeWidth={props.strokeWidth || 0.772414}
      strokeMiterlimit={10}
    />
  </svg>
);
export default ZigZag;
